// A custom React Hook that provides a sensible alternative to useRef for storing instance variables.

// React docs say:
// However, useRef() is useful for more than the ref attribute.
// It’s handy for keeping any mutable value around similar to how you’d use instance fields in classes.

import { useRef } from 'react';

const useInstance = (initialValue = {}) => {
  const ref = useRef();
  if (!ref.current) {
    ref.current = initialValue;
  }

  return ref.current;
};

export default useInstance;
